import { useTranslation } from "react-i18next";

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337";

const Instructions = ({ instructions }) => {
  const { t } = useTranslation();

  if (!Array.isArray(instructions)) return null;

  const renderRichText = (blocks) => {
    return blocks.map((block, index) => {
      if (block.type === "paragraph") {
        return (
          <p
            key={index}
            className="lead text-dark"
            style={{ lineHeight: "100%" }}
          >
            {block.children?.map((child, idx) => (
              <span key={idx}>{child.text}</span>
            ))}
          </p>
        );
      }
      return null; // Extend here for other block types like headings/lists
    });
  };

  return (
    <div className="container mt-10">
      <div className="row justify-content-center">
        <div className="col-12">
          <h2 className="mb-1 text-black">{t("recipe.instructions", "Instructions")}</h2>
          <ol className="list-group list-group-minimal col-12">
            {instructions
              .filter(item => item.title || item.text)
              .map((item, idx) => (
                <li
                  key={idx}
                  className="list-group-item text-black"
                >
                  {item.title && (
                    <h4 className="mt-3 display-6" style={{ lineHeight: "90%" }}>{item.title}</h4>
                  )}
                  
                  {/* Rich text rendering for item.text */}
                  {Array.isArray(item.text) && renderRichText(item.text)}

                  {/* Optional image rendering */}
                  {item.media?.[0]?.url && (
				  
				  	<img
					  src={`${STRAPI_URL}${item.media[0].url}`}
					  alt={item.title || ""}
					  className="col-12"
					  style={{ display: "block" }}
					/>
                  )}
                </li>
              ))}
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
